import React from "react";
import { CATEGORY_LABELS } from "../../constants/previewConfig";
import { SIZE_BUCKETS } from "../../utils/deviceUtils";

const CATEGORY_OPTIONS = ["all", "phone", "tablet", "laptop", "desktop", "custom"];

function DeviceFilters({
  category,
  setCategory,
  brand,
  setBrand,
  brands,
  year,
  setYear,
  years,
  hasOlderYears,
  size,
  setSize,
  orientation,
  setOrientation,
}) {
  return (
    <div className="device-filters">
      <div className="filter-pills" role="group" aria-label="Filter by category">
        {CATEGORY_OPTIONS.map((option) => (
          <button
            key={option}
            type="button"
            className={`filter-pill ${category === option ? "filter-pill-active" : ""}`}
            aria-pressed={category === option}
            onClick={() => setCategory(option)}
          >
            {option === "all" ? "All" : CATEGORY_LABELS[option]}
          </button>
        ))}
      </div>

      <div className="filter-selects">
        <div className="filter-select-field">
          <label htmlFor="brand-filter">Brand</label>
          <select id="brand-filter" value={brand} onChange={(event) => setBrand(event.target.value)}>
            <option value="all">All brands</option>
            {brands.map((b) => (
              <option key={b} value={b}>
                {b}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-select-field">
          <label htmlFor="year-filter">Release year</label>
          <select id="year-filter" value={year} onChange={(event) => setYear(event.target.value)}>
            <option value="all">Any year</option>
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
            {hasOlderYears && <option value="other">Older</option>}
          </select>
        </div>

        <div className="filter-select-field">
          <label htmlFor="size-filter">Screen size</label>
          <select id="size-filter" value={size} onChange={(event) => setSize(event.target.value)}>
            <option value="all">Any size</option>
            {Object.entries(SIZE_BUCKETS).map(([key, bucket]) => (
              <option key={key} value={key}>
                {bucket.label}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-select-field">
          <label htmlFor="orientation-filter">Orientation</label>
          <select
            id="orientation-filter"
            value={orientation}
            onChange={(event) => setOrientation(event.target.value)}
          >
            <option value="all">Any orientation</option>
            <option value="portrait">Portrait</option>
            <option value="landscape">Landscape</option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default DeviceFilters;
